import axios from 'axios';
import { refreshTokens } from './cognito';
import { getTokens, setTokens } from './tokens';

const APP_ID = 'management';
const ENV = process.env.REACT_APP_ENV;
const REGION = process.env.REACT_APP_REGION;
const WEBCLIENT_ID = process.env.REACT_APP_USER_POOL_WEBCLIENT_ID;
const WEB_URL = process.env.REACT_APP_WEB_URL;
const AUTH_URL = process.env.REACT_APP_AUTH_URL;
const DOMAIN_PREFIX = process.env.REACT_APP_USER_POOL_DOMAIN;
const DOMAIN = `https://${DOMAIN_PREFIX}.auth.${REGION}.amazoncognito.com`;

const redirectToAuth = async (action = 'login') => {
  const url = `${AUTH_URL}${action}?client_id=${WEBCLIENT_ID}`;
  window.location.href = url;
};

const getCurrentSession = async () => {
  const now = Math.round(new Date().getTime() / 1000);
  const { refreshToken, accessToken, idToken, exprTime } = getTokens();

  // if refreshToken has not expired, return values from localStorage
  if (now < exprTime && accessToken) {
    return {
      accessToken,
      idToken,
      exprTime: exprTime,
    };
  }

  if (refreshToken) {
    return await refreshTokens(refreshToken);
  }

  console.warn('No current session');
  return { accessToken: null, idToken: null };
};

const handleAuthCode = async (code) => {
  const queryString = Object.entries({
    code,
    redirect_uri: `${WEB_URL}auth/callback`,
    grant_type: 'authorization_code',
    client_id: WEBCLIENT_ID,
  })
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');

  const response = await axios.post(
    `${DOMAIN}/oauth2/token?${queryString}`,
    {},
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );

  const payload = response.data;
  const refreshToken = payload.refresh_token;
  const accessToken = payload.access_token;
  const idToken = payload.od_token;

  setTokens({
    RefreshToken: refreshToken,
    AccessToken: accessToken,
    IdToken: idToken,
  });

  return { refreshToken, accessToken, idToken };
};

export { APP_ID, getCurrentSession, handleAuthCode, redirectToAuth };
